import React, { useState, useEffect } from "react";
const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "60px 20px",
    flexWrap: "wrap",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  leftColumn: {
    flex: "1 1 300px",
    maxWidth: "400px",
    textAlign: "center",
  },
  // ── UNIFIED HEADING ──
  heading: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: "clamp(2.1rem, 4vw, 3rem)",
    fontWeight: 800,
    lineHeight: 1.15,
    color: "#1f2937",
    marginBottom: "12px",
    textAlign: "center",
  },
  // ── UNIFIED SUBHEADING ──
  subtitle: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "15.5px",
    fontWeight: 400,
    lineHeight: 1.75,
    color: "#6b7280",
    textAlign: "center",
  },
  rightColumn: {
    flex: "2 1 500px",
    position: "relative",
    height: "280px",
    display: "flex",
    justifyContent: "center",
    maxWidth: "1000px",
    width: "100%",
    overflow: "hidden",
  },
  cardBase: {
    position: "absolute",
    left: "50%",
    width: "320px",
    padding: "14px",
    background: "#fff",
    borderRadius: "18px",
    transition: "all 0.35s ease",
    cursor: "pointer",
  },
  image: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    borderRadius: "12px",
  },
};
const getCardStyle = (offset, isActive) => ({
  ...styles.cardBase,
  top: offset * 16,
  transform: isActive ? "translateX(-20%)" : "translateX(-50%)",
  boxShadow: isActive
    ? "0 22px 50px rgba(0,0,0,0.18)"
    : "0 12px 28px rgba(0,0,0,0.12)",
  zIndex: isActive ? 99 : 10 - offset,
  opacity: isActive ? 1 : 0.85,
});
const GoogleReviews = () => {
  const reviews = Array.from({ length: 35 }, (_, i) => ({
    image: `/images/googlereveiws/${i + 1}.png`,
  }));
  const [active, setActive] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % reviews.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [reviews.length]);
  return (
    <>
    <style>{`
      .google-reviews-wrap{
        background-image:url("/images/home/6.png");
        background-image:image-set(url("/images/home/6.avif") type("image/avif"), url("/images/home/6.webp") type("image/webp"), url("/images/home/6.png") type("image/png"));
      }
      @media (max-width:768px){
        .google-reviews-wrap{
          background-image:url("/images/home/6.png");
          background-image:image-set(url("/images/home/6-960.avif") type("image/avif"), url("/images/home/6-960.webp") type("image/webp"), url("/images/home/6.png") type("image/png"));
        }
      }
    `}</style>
    <div className="google-reviews-wrap" style={styles.wrapper}>
      <div style={styles.leftColumn}>
        <h2 style={styles.heading}>Google Reviews</h2>
        <p style={styles.subtitle}>What our learners say about us</p>
      </div>
      <div style={styles.rightColumn}>
        {reviews.map((review, index) => {
          const offset = index - active;
          if (offset < 0 || offset > 2) return null;
          const isActive = offset === 0;
          return (
            <div
              key={index}
              onClick={() => setActive(index)}
              style={getCardStyle(offset, isActive)}
            >
              <img
                src={review.image}
                alt={`Google Review ${index + 1}`}
                loading={index === 0 ? "eager" : "lazy"}
                decoding="async"
                width={320}
                height={220}
                style={styles.image}
              />
            </div>
          );
        })}
      </div>
    </div>
    </>
  );
};
export default GoogleReviews;